exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detailColumn{margin-top:10px;margin-bottom:10px}", ""]);

// exports
